import React, {useContext} from 'react';
import {Modal as MuiModal} from '@mui/material';
import classNames from 'classnames';

import {PathDesignContext} from 'src/components/path-design-context';
import CollegeImagesLightbox from 'shared/college-profile/components/about-college/college-images-lightbox';

import './image-modal.scss';

interface Props {
  show: boolean;
  onClose: () => void;
  image: React.ReactNode;
  onPageChange: (pageDirection: number) => () => void;
  currentPage: number;
  imageCount?: number;
  name?: string;
}

const ImageModal = ({show, onClose, image, onPageChange, currentPage, imageCount, name}: Props) => {
  const path = useContext(PathDesignContext);

  return (
    <MuiModal
      open={show}
      onClose={onClose}
      slotProps={{
        backdrop: {
          className: classNames('shared-image-modal-backdrop', {['--path']: path.enabled}),
        },
      }}
    >
      <div className="shared-image-modal">
        <CollegeImagesLightbox
          handleClose={onClose}
          changeLightboxPage={onPageChange}
          image={image}
          name={name}
          currentPage={currentPage}
          imageCount={imageCount}
        />
      </div>
    </MuiModal>
  );
};

export default ImageModal;
